<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos del Producto</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveProduct" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--half">
                <label for="name_es" class="form__label form__label--required">Nombre del Producto</label>
                <input type="text" class="form__input" name="name_es" id="name_es" placeholder="Nombre del Producto" v-model="product.name_es" v-validate="validation.name_es">
                <span v-show="errors.has('name_es')" class="form__alert">{{ errors.first('name_es') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="name_es" class="form__label form__label--required">Descripción</label>
                <textarea class="form__input form__input--textarea" name="text_es" id="text_es" placeholder="Descripción" v-model="product.text_es" v-validate="validation.text_es"></textarea>
                <span v-show="errors.has('text_es')" class="form__alert">{{ errors.first('text_es') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="group_id" class="form__label form__label--required">Grupo de Producto</label>
                <div class="form__select-container">
                  <select name="group_id" id="group_id" class="form__select" v-validate="validation.group_id" v-model="product.group_id">
                    <option :value="null">Seleccionar Grupo</option>
                    <option v-for="(group, index) in groups" :key="index" :value="group.id" v-text="group.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('group_id')" class="form__alert">{{ errors.first('group_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="type_id" class="form__label form__label--required">Tipo de Producto</label>
                <div class="form__select-container">
                  <select name="type_id" id="type_id" class="form__select" v-validate="validation.type_id" v-model="product.type_id">
                    <option :value="null">Seleccionar Tipo</option>
                    <option v-for="(type, index) in types" :key="index" :value="type.id" v-text="type.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('type_id')" class="form__alert">{{ errors.first('type_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="shape_id" class="form__label form__label--required">Forma de Producto</label>
                <div class="form__select-container">
                  <select name="shape_id" id="shape_id" class="form__select" v-validate="validation.shape_id" v-model="product.shape_id">
                    <option :value="null">Seleccionar Forma</option>
                    <option v-for="(shape, index) in shapes" :key="index" :value="shape.id" v-text="shape.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('shape_id')" class="form__alert">{{ errors.first('shape_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="weight_id" class="form__label form__label--required">Peso de Producto</label>
                <div class="form__select-container">
                  <select name="weight_id" id="weight_id" class="form__select" v-validate="validation.weight_id" v-model="product.weight_id">
                    <option :value="null">Seleccionar Peso</option>
                    <option v-for="(weight, index) in weights" :key="index" :value="weight.id" v-text="weight.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('weight_id')" class="form__alert">{{ errors.first('weight_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="suburb_id" class="form__label">Colonia</label>
                <span class="form__help">Selecciona la colonia relacionada a este producto en caso de ser necesario</span>
                <div class="form__select-container">
                  <select name="suburb_id" id="suburb_id" class="form__select" v-validate="validation.suburb_id" v-model="product.suburb_id">
                    <option :value="null">Seleccionar Colonia</option>
                    <option v-for="(suburb, index) in suburbs" :key="index" :value="suburb.id" v-text="suburb.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('suburb_id')" class="form__alert">{{ errors.first('suburb_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="gallery_id" class="form__label">Galería</label>
                <span class="form__help">Son las imágenes que se muestran en el slider bajo a la información general del producto</span>
                <div class="form__select-container">
                  <select name="gallery_id" id="gallery_id" class="form__select" v-validate="validation.gallery_id" v-model="product.gallery_id">
                    <option :value="null">Seleccionar Galería</option>
                    <option v-for="(gallery, index) in galleries" :key="index" :value="gallery.id" v-text="gallery.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('gallery_id')" class="form__alert">{{ errors.first('gallery_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="product.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <h2 class="form__subtitle">IMÁGENES DEL PRODUCTO</h2>

              <div class="form__container form__container--half">
                <label for="image1" class="form__label">Imagen 1</label>
                <input-viewer name="image1" v-model="images[0]" v-validate="validation.image1"></input-viewer>
                <span v-show="errors.has('image1')" class="form__alert">{{ errors.first('image1') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="image2" class="form__label">Imagen 2</label>
                <input-viewer name="image2" v-model="images[1]" v-validate="validation.image2"></input-viewer>
                <span v-show="errors.has('image2')" class="form__alert">{{ errors.first('image2') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="image3" class="form__label">Imagen 3</label>
                <input-viewer name="image3" v-model="images[2]" v-validate="validation.image3"></input-viewer>
                <span v-show="errors.has('image3')" class="form__alert">{{ errors.first('image3') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>

        <section class="main__section">
          <form class="form" v-if="!loading">
            <h2 class="form__subtitle">COLORES</h2>
            <span v-if="!colors" class="form__help">Antes de agregar los colores debe crear el producto, una vez creado aparecerán las opciones para agregar los colores</span>

            <ul class="list" v-if="product.colors">
              <li class="list__item" v-for="(item, index) in attributes.colors" :key="index">
                {{'Color: ' + item.name_es}}
                <button @click.prevent="removeAttribute('colors', index, item.id)" class="list__remove">Quitar X</button>
                </li>
            </ul>

            <div v-if="colors" class="form__container form__container--short">
              <label for="weight_id" class="form__label form__label--required">Color</label>
              <div class="form__select-container">
                <select name="product_color" id="product_color" class="form__select" v-model="product_color">
                  <option :value="null">Seleccionar Color</option>
                  <option v-for="(color, index) in colors" :key="index" :value="color" v-text="color.name_es"></option>
                </select>
              </div>
            </div>

            <button v-if="colors" class="btn btn--small btn__default" @click.prevent="addAttribute('colors', product_color)">AGREGAR COLOR</button>

            <h2 class="form__subtitle">TAMAÑOS</h2>
            <span v-if="!sizes" class="form__help">Antes de agregar los tamaños debe crear el producto, una vez creado aparecerán las opciones para agregar los tamaños</span>

            <ul class="list" v-if="product.sizes">
              <li class="list__item" v-for="(item, index) in attributes.sizes" :key="index">
                {{'Tamaño: ' + item.name_es}}
                <button @click.prevent="removeAttribute('sizes', index, item.id)" class="list__remove">Quitar X</button>
                </li>
            </ul>

            <div  v-if="sizes" class="form__container form__container--short">
              <label for="weight_id" class="form__label form__label--required">Tamaño</label>
              <div class="form__select-container">
                <select name="product_size" id="product_size" class="form__select" v-model="product_size">
                  <option :value="null">Seleccionar Tamaño</option>
                  <option v-for="(size, index) in sizes" :key="index" :value="size" v-text="size.name_es"></option>
                </select>
              </div>
            </div>

            <button  v-if="sizes" class="btn btn--small btn__default" @click.prevent="addAttribute('sizes', product_size)">AGREGAR TAMAÑO</button>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'productList', params: {page: 1}}">Lista de Productos</router-link>
        <router-link v-if="$route.name === 'productEdit'" class="btn btn--small btn__default" :to="{name: 'productNew'}">Nuevo Producto</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, productFields, statusList, texts} from './moks'
import inputViewer from '@/components/media/input'
export default {
  mixins: [httpService],
  components: {inputViewer},
  data: function () {
    return {
      validation: validation,
      product: null,
      types: [],
      groups: [],
      shapes: [],
      weights: [],
      sizes: [],
      colors: [],
      suburbs: [],
      galleries: [],
      colors: null,
      sizes: null,
      product_color: null,
      product_size: null,
      statusList: statusList,
      images: [],
      attributes: {
        sizes: [],
        colors: []
      }
    }
  },
  created: function () {
    this.start()
  },
  watch: {
    '$route.path': function () {
      this.images = []
      this.colors = null
      this.sizes = null
      this.start()
    }
  },
  methods: {
    start: function () {
      this.getTypes(7)
        .then(
          result => {
            this.types = result
          } 
        )
      this.getTypes(4)
        .then(
          result => {
            this.shapes = result
          } 
        )
      this.getTypes(5)
        .then(
          result => {
            this.weights = result
          } 
        )
      this.getTypes(6)
        .then(
          result => {
            this.groups = result
          } 
        )
        if (this.$route.name === 'productEdit') {
          this.getTypes(2)
            .then(
              result => {
                this.sizes = result
              } 
            )
          this.getTypes(3)
            .then(
              result => {
                this.colors = result
              } 
            ) 
        }
      this.getSuburbs()
      this.getGalleries()
      if (this.productId) {
        this.getAttr()
      }
      if (!this.productId) {
        this.product = new productFields()
      }
    },
    getTypes: function (type) {
      return new Promise((resolve, reject) => {
        let httpRequest = {
          params: '?fields=id,name_es,image&type_id=eq:' + type,
          module: 'attributes'
        }
        this.get(httpRequest)
          .then(
            types => {
              resolve(types.data)
            }
          ).catch(
            () => {
              resolve([])
            }
          )
      })
    },
    getSuburbs: function () {
      let httpRequest = {
        params: '?fields=id,name_es',
        module: 'suburbs'
      }
      this.get(httpRequest)
        .then(
          suburbs => {
            this.suburbs = suburbs.data
          }
        ).catch(
          () => {
            this.suburbs = []
          }
        )
    },
    getGalleries: function () {
      let httpRequest = {
        params: '?fields=id,name',
        module: 'galleries'
      }
      this.get(httpRequest)
        .then(
          galleries => {
            this.galleries = galleries.data
          }
        ).catch(
          () => {
            this.galleries = []
          }
        )
    },
    getAttr: function () {
      let httpRequest = {
        params: '',
        module: 'products'
      }
      this.getById(this.productId, httpRequest)
        .then(
          product => {
            this.product = product.data
            if (product.data.images) {
              this.images = JSON.parse(product.data.images)
            }
            if (product.data.colors) {
              this.attributes.colors = product.data.colors
            }
            if (product.data.sizes) {
              this.attributes.sizes = product.data.sizes
            }
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'productNew'})
          }
        )
    },
    saveProduct: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              this.product.images = JSON.stringify(this.images)
              this.product.colors = JSON.stringify(this.attributes.colors)
              this.product.sizes = JSON.stringify(this.attributes.sizes)
              let httpRequest = {
                params: '',
                module: 'products',
                element: this.product
              }
              let request
              if (this.$route.name === 'productEdit') {
                request = this.put(this.productId, httpRequest)
              } else if (this.$route.name === 'productNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'productNew') {
                    this.$router.push({name: 'productEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    },
    addAttribute: function (attribute, data) {
      if (!this.attributes[attribute]) {
        this.attributes[attribute] = []
      }
      this.attributes[attribute].push(data)
      let httpRequest = {
        params: '',
        module: 'product_attributes',
        element: {
          product_id: this.productId,
          attribute_id: data.id
        }
      }
      this.post(httpRequest)
        .then(
          () => {
            this.$store.commit('notificate', {
              title: 'ATRIBUTO CREADO',
              text: 'El attibuto ha sido agregado de forma correcta a este producto',
              type: 'success'
            })
          }
        )
    },
    removeAttribute: function (attribute, index, id) {
      this.attributes[attribute].splice(index, 1)
      let httpRequest = {
        params: '',
        module: 'product_attributes'
      }
      this.delete(id, httpRequest)
        .then(
          () => {
            this.$store.commit('notificate', {
              title: 'ATRIBUTO BORRADO',
              text: 'El attibuto ha sido borrado de forma correcta de este producto',
              type: 'success'
            })
          }
        )
    }
  },
  computed: {
    productId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.product
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/objects/_elements"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/products/edit.vue